import React from 'react';
import './Footer.scss';

import whiteLogo from '../../images/white_logo.svg';
import arrowUp from '../../images/arrow-up.svg';
import facebookIcon from '../../images/facebook.svg';
import instagramIcon from '../../images/instagram.svg';
import youtubeIcon from '../../images/youtube.svg';
import { Link } from 'react-router-dom';

const Footer = () => {
  const scrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });
  return (
    <div className="footer">
      <div className="footer__message">
        <p className="footer__message-p">
          Con nuestro cotizador, podrás elegir todas las características del
          carro de tus sueños y nosotros te asesoramos en el proceso.
        </p>
      </div>
      <div className="footer__social-bar">
        <div className="footer__social-left">
          <div className="footer__social-option">
            <a className="footer__social-link" href="https://www.facebook.com/VeinsaMotors/" target="_blank" rel="noopener noreferrer">
              <img
                className="footer__social-image"
                src={facebookIcon}
                alt="Facebook"
              />
            </a>
          </div>
          <div className="footer__social-option">
            <a className="footer__social-link" href="https://www.instagram.com/veinsamotors/" target="_blank" rel="noopener noreferrer">
              <img
                className="footer__social-image"
                src={instagramIcon}
                alt="Instagram"
              />
            </a>
          </div>
          <div className="footer__social-option">
            <a className="footer__social-link" href="https://www.youtube.com/channel/UC_gg688X_DEaHnT_yg73xSw" target="_blank" rel="noopener noreferrer">
              <img
                className="footer__social-image"
                src={youtubeIcon}
                alt="Youtube"
              />
            </a>
          </div>
        </div>
        <div className="footer__social-right">
          <div className="footer__social-option">
            <span className="footer__contactanos-link">Contactanos</span>
            <span className="footer__phone">(+506) 4000-8000</span>
          </div>
        </div>
      </div>
      <div className="footer__main">
        <div className="footer__sections">
          <button onClick={scrollTop} className="footer__return">
            <img src={arrowUp} alt="Arrow up" />
          </button>
          <div className="footer__logo">
            <Link to={'/'}>
              <img src={whiteLogo} alt="Veinsa" className="footer__logo-image" />
            </Link>
          </div>
          <div className="footer__section">
            <p className="footer__title">Marcas</p>
            <ul className="marcas">
              <li className="marcas__group">
                <ul>
                  <li className="marcas__marca">
                    <a
                      className="marcas__marca-link"
                      href="http://mitsubishi.cr/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Mitsubishi
                    </a>
                  </li>
                  <li className="marcas__marca">
                    <a
                      className="marcas__marca-link"
                      href="http://www.ssangyongcr.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Ssangyong
                    </a>
                  </li>
                  <li className="marcas__marca">
                    <a
                      className="marcas__marca-link"
                      href="http://www.citroencr.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Citroën
                    </a>
                  </li>
                </ul>
              </li>
              <li className="marcas__group">
                <ul>
                  <li className="marcas__marca">
                    <a
                      className="marcas__marca-link"
                      href="http://www.peugeot.co.cr/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Peugeot
                    </a>
                  </li>
                  <li className="marcas__marca">
                    <a
                      className="marcas__marca-link"
                      href="http://www.maserati.cr/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Maserati
                    </a>
                  </li>
                  <li className="marcas__marca">
                    <a
                      className="marcas__marca-link"
                      href="http://www.geely.cr/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Geely
                    </a>
                  </li>
                </ul>
              </li>
              <li className="marcas__group">
                <ul>
                  {/* <li className="marcas__marca">
                    <a
                      className="marcas__marca-link"
                      href="https://veinsamotors.com/cotizador/Camion/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Fuso
                    </a>
                  </li> */}
                  <li className="marcas__marca">
                    <a
                      className="marcas__marca-link"
                      href="http://www.jmc.cr/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      JMC
                    </a>
                  </li>
                  <li className="marcas__marca">
                    <a
                      className="marcas__marca-link"
                      href="https://www.mahindra.cr/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Mahindra
                    </a>
                  </li>
                  <li className="marcas__marca">
                    <a
                      className="marcas__marca-link"
                      href="https://www.farizon.cr/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Farizon
                    </a>
                  </li>
                  <li className="marcas__marca">
                    <a
                      className="marcas__marca-link"
                      href="/cotizador"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Weltmeister
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
          <div className="footer__section footer__section--somos">
            <div className="footer__section">
              <a
                href="https://veinsamotors.com/somos-veinsa/"
                target="_blank"
                rel="noopener noreferrer"
                className="footer__title"
              >
                Somos Veinsa
              </a>
            </div>
            <div className="footer__section">
              <a
                href="https://veinsamotors.com/promociones/"
                className="footer__title"
                rel="noopener noreferrer"
              >
                Promociones
              </a>
            </div>
            <div className="footer__section">
              <a
                href="https://veinsamotors.com/mantenimiento/"
                className="footer__title"
                rel="noopener noreferrer"
              >
                Servicio Post-Venta
              </a>
            </div>
            <div className="footer__section">
              <a
                href="https://veinsamotors.com/blog/"
                className="footer__title"
                rel="noopener noreferrer"
              >
                Blog
              </a>
            </div>
            <div className="footer__section">
              <a
                href="https://veinsamotors.com/contacto/"
                className="footer__title"
                rel="noopener noreferrer"
              >
                Contacto
              </a>
            </div>
          </div>
        </div>
        <ul className="footer__bottom-bar">
          <li className="footer__bottom-item">
            <a href="/" className="footer__bottom-link">
              {(new Date().getFullYear())} © VeinsaMotors
            </a>
          </li>
          <li className="footer__pipe">|</li>
          <li className="footer__bottom-item">
            <span className="footer__bottom-copyright">Copyright</span>
            <span>TODOS LOS DERECHOS RESERVADOS</span>
          </li>
          <li className="footer__pipe">|</li>
          <li className="footer__bottom-item">
            <a
              href="https://veinsamotors.com/notas-legales"
              className="footer__bottom-link"
            >
              NOTAS LEGALES
            </a>
          </li>
          <li className="footer__pipe">|</li>
          <li className="footer__bottom-item">
            <a href="https://veinsamotors.com/recall/" className="footer__bottom-link" target="_blank" without rel="noopener noreferrer">Recall</a>
          </li>
        </ul>
      </div>
    </div>
  );
};
export default Footer;
